module.exports = __webpack_public_path__ + "static/media/white-rose.923bf449.png";